<div libClickOutSide (clickOutside)="closeOnOutsideClick()">
  <button
    type="button"
    [attr.data-quick-action]="key()"
    [attr.aria-label]="action().label"
    [attr.aria-expanded]="isOpen()"
    [attr.title]="action().label"
    class="flex size-3xl shrink-0 items-center justify-center rounded-md bg-neutral-100 text-neutral-500 hover:bg-neutral-200 hover:text-neutral-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
    (click)="toggle()">
    <lib-side-menu-icon name="add" iconClass="size-4" />
  </button>
  @if (isOpen()) {
    <div
      data-quick-action-panel
      class="fixed z-50 w-[18.75rem] rounded-lg bg-white shadow-xl"
      [style.top.px]="panelTop()"
      [style.inset-inline-start.px]="panelStart()">
      <ng-container [ngTemplateOutlet]="action().template" />
    </div>
  }
</div>
